module.exports = __webpack_public_path__ + "img/scrub5.714d28a8.jpg";